import { RefreshCw } from "lucide-react";
import React, { useState } from "react";
import AdminPageLayout from "../../../components/AdminPageLayout";
import { useTheme } from "../../../contexts/ThemeContext";
import JobExecutionsTable from "./JobExecutionsTable";
import JobList from "./JobList";



const JobsDashboard: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <AdminPageLayout
      title="Job Management"
      description="Manage system jobs, trigger manual executions, and view history"

      actions={
        <button
          onClick={handleRefresh}
          className={`px-4 py-2 rounded-lg transition-colors flex items-center ${
            isDarkMode
              ? "text-rp-grey/70 hover:text-rp-grey hover:bg-rp-surface-raised"
              : "text-gray-600 hover:text-gray-700 hover:bg-gray-100"
          }`}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </button>
      }
    >

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column: Available Jobs */}
          <div className="lg:col-span-1">
            <JobList refreshTrigger={refreshTrigger} />
          </div>

          {/* Right Column: Execution History */}
          <div className="lg:col-span-2">
            <div className={`${isDarkMode ? "bg-rp-surface" : "bg-white"} rounded-lg shadow`}>
              <div className={`px-6 py-4 border-b ${isDarkMode ? "border-rp-separator" : "border-gray-200"}`}>
                <h2 className={`text-lg font-medium ${isDarkMode ? "text-rp-grey" : "text-gray-900"}`}>Execution History</h2>
              </div>
              <div className="p-6">
                <JobExecutionsTable refreshTrigger={refreshTrigger} />
              </div>
            </div>
          </div>
        </div>
    </AdminPageLayout>
  );
};

export default JobsDashboard;
